import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import {MatDynamicTableComponent} from './mat-dynamic-table.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {
  MatButtonModule,
  MatFormFieldModule,
  MatInputModule,
  MatPaginatorModule,
  MatSortModule,
  MatTableModule,
  MatTooltipModule
} from '@angular/material';
import {TranslateModule} from '@ngx-translate/core';
import {NullOrUndefinedHandlerPipeModule, RandomGradientPipeModule, TimeAgoPipeModule} from '@bd-innovations/pipe-collection';
import {DomElementValidatorDirectiveModule, ShortPressDirectiveModule} from '@bd-innovations/directive-collection';
import {MatDynamicTableModuleConfigInjectionToken, MatDynamicTableService} from './mat-dynamic-table.service';
import {MatDynamicTableModuleConfig} from './configs/mat-dynamic-table-module.config';

@NgModule({
  declarations: [
    MatDynamicTableComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    MatTooltipModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatButtonModule,

    TranslateModule,

    TimeAgoPipeModule,
    RandomGradientPipeModule,
    NullOrUndefinedHandlerPipeModule,
    DomElementValidatorDirectiveModule,
    ShortPressDirectiveModule,
  ],
  exports: [
    MatDynamicTableComponent,
  ],
  providers: [
    DatePipe,
    MatDynamicTableService,
  ]
})
export class MatDynamicTableModule {
  static forRoot(serviceConfig: MatDynamicTableModuleConfig): ModuleWithProviders {
    return {
      ngModule: MatDynamicTableModule,
      providers: [
        MatDynamicTableService,
        {
          provide: MatDynamicTableModuleConfigInjectionToken,
          useValue: serviceConfig
        }
      ]
    };
  }

  static forChild(serviceConfig: MatDynamicTableModuleConfig): ModuleWithProviders {
    return {
      ngModule: MatDynamicTableModule,
      providers: [
        MatDynamicTableService,
        {
          provide: MatDynamicTableModuleConfigInjectionToken,
          useValue: serviceConfig
        }
      ]
    };
  }
}
